import { useEffect } from "react";

export function getSavedLanguage() {
  const value = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("cookie_accesslang_trustedpay="))
    ?.split("=")[1];

  return value === "en" ? "en" : "vi";
}

export function setLanguage(language) {
  document.cookie = `cookie_accesslang_trustedpay=${language}; Path=/; Max-Age=31536000; SameSite=Lax`;
}

const RootRedirect = () => {
  useEffect(() => {
    const language = getSavedLanguage();
    window.location.replace(
      process.env.PUBLIC_URL + (language === "en" ? "/en" : "/vi"),
    );
  }, []);

  return null;
};

export default RootRedirect;
